module.exports = __webpack_public_path__ + "img/qrimg.c68c316f.jpg";